import styled from 'styled-components';

import { spaceL, spaceXS, xdlColorText } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

export const Subheader = styled.div`
  display: flex;
  gap: ${spaceL};
  margin-bottom: ${spaceL};

  & svg {
    color: ${xdlColorText};
  }
`;

export const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXS};
  justify-content: center;
`;

export const Industry = styled(Meta)`
  margin-bottom: 0;
`;
